/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* -------------------------------------------------------------------------
   * Subscription-aware Add to Cart price
   *
   * The theme's product-info.js updates the ATC button price ([data-product-price])
   * from variant.price only, so it ignores the selected Shopify Subscriptions
   * selling plan. This re-computes that price using the selected selling plan's
   * allocation (variant.selling_plan_allocations), which the theme already
   * outputs in the [data-selected-variant] JSON. Reverts to the one-time price
   * when "One-time purchase" is selected.
   *
   * Reuses the theme helpers (window.theme.formatMoney / strings / moneyFormat
   * and the global pub/sub) so formatting stays consistent with the theme.
   * ---------------------------------------------------------------------- */
  // Toggle this to false to silence logging once it's working.
  var SUB_PRICE_DEBUG = true;
  function log() {
    if (!SUB_PRICE_DEBUG || !window.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[sub-price]');
    console.log.apply(console, args);
  }

  log('script loaded. theme?', !!window.theme,
      '| formatMoney?', !!(window.theme && typeof window.theme.formatMoney === 'function'),
      '| subscribe?', typeof subscribe === 'function',
      '| PUB_SUB_EVENTS?', !!(window.theme && theme.PUB_SUB_EVENTS));

  function getSelectedPlanId(productInfo) {
    var form = productInfo.querySelector('form[data-product-form]') ||
               productInfo.querySelector('product-form form');
    if (!form) {
      log('getSelectedPlanId: no product form found');
      return '';
    }
    var allInputs = form.querySelectorAll('[name="selling_plan"]');
    log('getSelectedPlanId: selling_plan inputs in form =', allInputs.length);
    try {
      var id = new FormData(form).get('selling_plan') || '';
      log('getSelectedPlanId: FormData selling_plan =', JSON.stringify(id));
      return id;
    } catch (e) {
      log('getSelectedPlanId: FormData error', e);
      return '';
    }
  }

  function getSelectedVariant(productInfo) {
    var el = productInfo.querySelector('[data-selected-variant]');
    if (!el) {
      log('getSelectedVariant: no [data-selected-variant] element');
      return null;
    }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      log('getSelectedVariant: JSON parse error', e);
      return null;
    }
  }

  function updateSubscriptionPrice(productInfo) {
    if (!productInfo) {
      log('updateSubscriptionPrice: no productInfo');
      return;
    }
    var priceEl = productInfo.querySelector('[data-product-price]');
    if (!priceEl) {
      log('updateSubscriptionPrice: no [data-product-price] element (atc_show_product_price setting off?)');
      return;
    }
    if (!window.theme || typeof window.theme.formatMoney !== 'function') {
      log('updateSubscriptionPrice: theme.formatMoney unavailable');
      return;
    }

    var variant = getSelectedVariant(productInfo);
    if (!variant) return;

    var planId = getSelectedPlanId(productInfo);
    var price = variant.price || 0;
    var compareAt = variant.compare_at_price || 0;

    var allocations = variant.selling_plan_allocations || [];
    log('variant id', variant.id, '| one-time price', price,
        '| allocations', allocations.length,
        '| allocation plan ids', allocations.map(function(a) { return a.selling_plan_id; }));

    if (planId) {
      var matched = false;
      for (var i = 0; i < allocations.length; i++) {
        if (String(allocations[i].selling_plan_id) === String(planId)) {
          price = allocations[i].price;
          compareAt = allocations[i].compare_at_price || 0;
          matched = true;
          log('matched allocation for plan', planId, '-> price', price, '| compareAt', compareAt);
          break;
        }
      }
      if (!matched) {
        log('NO allocation matched plan id', JSON.stringify(planId),
            '- falling back to one-time price. Check that this id exists in the list above.');
      }
    } else {
      log('no plan selected (one-time) -> using variant price', price);
    }

    var qtyInput = productInfo.querySelector('[data-quantity-input]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    var total = price * qty;
    var compareTotal = compareAt > price ? compareAt * qty : 0;

    var html = total === 0 ?
      (window.theme.strings && window.theme.strings.free ? window.theme.strings.free : '') :
      window.theme.formatMoney(total, theme.moneyFormat);

    if (compareTotal) {
      html = html + ' <s>' + window.theme.formatMoney(compareTotal, theme.moneyFormat) + '</s>';
    }

    log('writing button price html ->', html);
    priceEl.innerHTML = html;
  }

  // Run after the theme / subscription app has finished its synchronous DOM
  // updates. Coalesce multiple events in the same frame into one recompute.
  var pending = new WeakSet();
  function scheduleUpdate(productInfo) {
    if (!productInfo || pending.has(productInfo)) return;
    pending.add(productInfo);
    requestAnimationFrame(function() {
      pending.delete(productInfo);
      updateSubscriptionPrice(productInfo);
    });
  }

  function updateAll() {
    var nodes = document.querySelectorAll('product-info');
    log('updateAll: product-info elements on page =', nodes.length);
    nodes.forEach(scheduleUpdate);
  }

  // The native Shopify Subscriptions widget sets the hidden [name="selling_plan"]
  // input's value with JS, which does NOT emit a change event on that input.
  // So instead we listen for any interaction inside product-info and re-read the
  // current selling_plan value a frame later (after the widget has updated it).
  function handleInteraction(e) {
    var productInfo = e.target && e.target.closest && e.target.closest('product-info');
    if (!productInfo) return;
    log('interaction (' + e.type + ') inside product-info ->', e.target.tagName,
        e.target.name ? '[name=' + e.target.name + ']' : '', e.target.className || '');
    scheduleUpdate(productInfo);
  }
  document.addEventListener('change', handleInteraction, true);
  document.addEventListener('click', handleInteraction, true);

  // Re-apply after the theme overwrites the button price on variant / quantity change.
  if (typeof subscribe === 'function' && window.theme && theme.PUB_SUB_EVENTS) {
    if (theme.PUB_SUB_EVENTS.variantChange) {
      subscribe(theme.PUB_SUB_EVENTS.variantChange, function(payload) {
        var sectionId = payload && payload.data && payload.data.sectionId;
        var productInfo = sectionId ?
          document.querySelector('product-info[data-section="' + sectionId + '"]') : null;
        if (productInfo) {
          scheduleUpdate(productInfo);
        } else {
          updateAll();
        }
      });
    }
    if (theme.PUB_SUB_EVENTS.quantityUpdate) {
      subscribe(theme.PUB_SUB_EVENTS.quantityUpdate, updateAll);
    }
  }

  // Catch direct quantity input changes too (covered by rAF ordering).
  document.addEventListener('change', function(e) {
    if (e.target && e.target.matches && e.target.matches('[data-quantity-input]')) {
      var productInfo = e.target.closest('product-info');
      if (productInfo) scheduleUpdate(productInfo);
    }
  });

  // Initial pass on load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }

  /* -------------------------------------------------------------------------
   * Keep the dynamic checkout ("Buy it now") button bound to the right variant
   *
   * The dynamic checkout button is now always present in the DOM (see
   * product-buttons.liquid) so it can reappear when switching from a sold-out
   * variant to an available one.
   *
   * Two things break the express checkout when the page loads on a sold-out
   * variant and the shopper then picks an available one:
   *
   * 1. Stale variant id input. The product template renders a second
   *    name="id" input that lives OUTSIDE the <form> (associated by the form=
   *    attribute, in product.liquid). The theme's updateVariantInputs only
   *    updates name="id" inputs that are descendants of the form, so this one
   *    keeps the variant id the page loaded with. The express button submits the
   *    form, reads that stale id, and Shopify returns "this item is no longer
   *    available." We sync every name="id" input to the selected variant.
   *
   * 2. Stale button init. Shopify's express button initializes once against the
   *    variant selected at load. We swap the live button markup for the freshly
   *    fetched markup (payload.data.html) and call Shopify.PaymentButton.init()
   *    so it re-initializes against the current variant, mirroring how Shopify's
   *    own reference themes refresh the button.
   * ---------------------------------------------------------------------- */
  function syncVariantIdInputs(productInfo, variant) {
    if (!productInfo || !variant || !variant.id) return;
    productInfo.querySelectorAll('input[name="id"]').forEach(function(input) {
      input.value = variant.id;
      input.disabled = false;
    });
  }

  function refreshDynamicCheckout(productInfo, fetchedDoc) {
    if (!productInfo || !fetchedDoc) return;
    var liveItem = productInfo.querySelector('.product__submit__item--dynamic');
    var fetchedItem = fetchedDoc.querySelector('.product__submit__item--dynamic');
    if (!liveItem || !fetchedItem) return;

    liveItem.innerHTML = fetchedItem.innerHTML;

    if (window.Shopify && window.Shopify.PaymentButton &&
        typeof window.Shopify.PaymentButton.init === 'function') {
      window.Shopify.PaymentButton.init();
    }
  }

  if (typeof subscribe === 'function' && window.theme && theme.PUB_SUB_EVENTS &&
      theme.PUB_SUB_EVENTS.variantChange) {
    subscribe(theme.PUB_SUB_EVENTS.variantChange, function(payload) {
      var data = payload && payload.data;
      if (!data) return;
      var productInfo = data.sectionId ?
        document.querySelector('product-info[data-section="' + data.sectionId + '"]') : null;
      if (!productInfo) return;
      syncVariantIdInputs(productInfo, data.variant);
      refreshDynamicCheckout(productInfo, data.html);
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
